import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    landingPageAds: [],
    loading: false,
    error: null
};

const landingPageAdsReducer = createSlice({
    name: "landingPageAdsReducer",
    initialState: initialState,
    reducers: {
        updateLandingPageAds: (state, { payload }) => {
            state.landingPageAds = Array.isArray(payload) ? payload : [];
        },
        updateLoadingLandingPageAds: (state, { payload }) => {
            state.loading = payload;
        },
        updateErrorLandingPageAds: (state, { payload }) => {
            state.error = payload;
        },
        clearLandingPageAds: (state) => {
            state.landingPageAds = [];
            state.loading = false;
            state.error = null;
        }
    }
});

export const { 
    updateLandingPageAds, 
    updateLoadingLandingPageAds, 
    updateErrorLandingPageAds, 
    clearLandingPageAds 
} = landingPageAdsReducer.actions;

export default landingPageAdsReducer.reducer;
